import { Injectable} from '@angular/core';
import { Headers, RequestOptions, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

import { ElasticSearchService } from './search-elasticsearch.service';

@Injectable()
export class SearchService {

    private baseUrl = '/api/content/';

    private headers = new Headers({ 'Content-Type': 'application/json' });
    private options = new RequestOptions({ headers: this.headers });

    constructor(private http: Http, private es: ElasticSearchService) {}

    search(type: string, query: any) {
        return this.http.post('/api/index/'+type+'/search', query, this.options)
            .toPromise()
            .then(response => {
                return response.json()
            })
    }

    suggest(type: string, term: string) {
        // /api/index/record/suggest/fr/moza
        return this.http.get('/api/index/'+type+'/suggest/'+term)
            .toPromise()
            .then(response => {
                return response.json()
            })
    }

    mlt(type: string, id: string) {
        // /api/index/record/mlt/595805ba0de2df2fd87fdf24
        return this.http.get('/api/index/'+type+'/mlt/'+id)
            .toPromise()
            .then(response => {
                return response.json()
            })
    }

    autocomplete(type: string, field: string, input: string) {
        // /api/index/record/suggest/fr/moza
        return this.http.get('/api/index/'+type+'/autocomplete/'+field+'/'+input)
            .toPromise()
            .then(response => {
                return this.es.formatSuggestions(response.json().suggest);
            })
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/search.service.ts